<template>
    <div class="equity-common-content">
        <div class="e-common-frames">
            <div class="e-top e-common-block">
                <div class="e-common-lr">
                    <div class="e-left">
                          <img src="@/assets/images/e-tjx-xjjd-icon@2x.png" alt="">
                    </div>
                    <div class="e-right">
                        <h3>星级酒店健身礼遇</h3>
                        <p>免费享受星级酒店健身、游泳礼遇。</p>
                    </div>
                </div>
            </div>
            <div class="e-bottom e-common-block">
                <h2>温馨提示</h2>
                <p class="bold">细则1</p>
                <p>钛金鑫卡持卡人全年尊享24次星级酒店健身服务。</p>
                <p class="bold">细则2</p>
                <p>本行将在您激活人民币卡后的3个工作日内为您开通权益服务。</p>
                <p class="bold">细则3</p>
                <p>您需提前24小时通过本行信用卡微信公众号预订场地,场地预订成功后会给您发送预订成功短信,届时您仅凭短信验证码及身份证明下场体验。您可预订8个自然日之内的星级酒店健身、游泳服务；如您在当天下午17点之前提交预约,则可预定次日服务；如预约时间在17点之后,则最早可预订第三天的服务。</p>
                <p class="bold">细则4</p>
                <p>如您因故不能按约定时间使用权益,请提前至少24小时通过本行信用卡微信公众号进行取消,否则视为缺席,缺席等同于使用,同样计入免费权益礼遇内。</p>
                <p class="bold">细则5</p>
                <p>预订成功后如需继续预约,需将上一次权益使用完以后,再可预订下次服务。</p>
                <p class="bold">细则6</p>
                <p>如在健身中心享用其它设施和服务,则需另外付费。</p>
                <p class="bold">细则7</p>
                <p>本服务仅限本人使用,每次可携带3名以内亲友一并入内,您及您的亲友每人每次使用服务次数都将从您当年免费次数中扣除。</p>
                <p class="bold">细则8</p>
                <p>酒店每天可接待数量有限,按会员预约时间先到先得,预约成功与否按该酒店实际预约情况而定。</p>
                <p class="bold">细则9</p>
                <p>健身设施的使用须遵守该酒店的规定,例如使用者的年龄限制、健身设施的开放时间、着装等。</p>
                <p class="bold">细则10</p>
                <p>所有注意事项只限目前所知情形,不排除具体预订时有所更改,请以最终预订提醒及客服告知为准。</p>
                <p class="bold">细则11</p>
                <p>星级酒店健身、游泳覆盖酒店请以我行信用卡权益平台服务预订显示为准。</p>
            </div>
            <div class="banner-detail-btn" @click="xjjdPush"><img src="@/assets/images/tjx/banner_tjx_xjjd.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods:{
            xjjdPush(){
                this.$test('tjx xjjd-banner')
                // console.log('星际酒店')
                this.$router.push('/servicetable/xjjd')
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>